export default {
  buttonContainer: {
    marginTop: '32px'
  }
}
